<div class="main-loader">
  <img src="{{vLoader}}" alt="" />
  <div class="loader-index">
    <div class="loader-index-circle"></div>
  </div>
</div>
